import { render } from "./NumberLogout.vue?vue&type=template&id=32a4ebd4&scoped=true&ts=true"
import script from "./NumberLogout.vue?vue&type=script&lang=ts"
export * from "./NumberLogout.vue?vue&type=script&lang=ts"

import "./NumberLogout.vue?vue&type=style&index=0&id=32a4ebd4&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a4ebd4"]])

export default __exports__